import React, {Fragment} from "react";
import Box from "./layout/Box";
import connect from "react-redux/es/connect/connect";
import {setFormValues} from "../actions";

export const version = "0.1";

export class ReleaseInfo extends React.Component {

    static version = version;

    componentDidMount() {
        if (this.props.values.version !== version) {
            this.props.setFormValues("ReleaseInfo", {version});
        }
    }

    render() {
        return (
            <Box
                header="Frissítés információk"
            >

            </Box>
        );
    }
}

export default connect((state) => ({values: ((state.editors.ReleaseInfo || {}).values || {})}), {setFormValues})(ReleaseInfo);